import { Text } from '@components/primitives/Text'

export const FooterCTA = ({
  children,
  headline,
  subtitle,
}: {
  children?: React.ReactNode

  headline: string
  subtitle: string
}) => {
  return (
    <>
      <div className='relative z-[8] items-center overflow-hidden bg-neutral900 px-6 py-24 text-center shadow-2xl md:rounded-3xl md:px-16'>
        <Text
          className='mb-4 text-neutral50'
          element='h2'
          styleName='h2'
          value={headline}
        />
        <Text
          className='mx-auto mb-6 max-w-xl text-neutral400'
          element='p'
          styleName='p'
          value={subtitle}
        />

        {/* this is where put CTA button */}
        {children}

        <svg
          aria-hidden='true'
          className='absolute left-1/2 top-1/4 z-[8] size-[64rem] -translate-x-1/2'
          fill='none'
          viewBox='0 0 1024 1024'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g filter='url(#filter0_f_214_29697)' opacity='0.6'>
            <circle cx='514.5' cy='514.5' fill='#926CFF' r='314.5' />
          </g>
          <defs>
            <filter
              colorInterpolationFilters='sRGB'
              filterUnits='userSpaceOnUse'
              height='1029'
              id='filter0_f_214_29697'
              width='1029'
              x='0'
              y='0'
            >
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feBlend
                in='SourceGraphic'
                in2='BackgroundImageFix'
                mode='normal'
                result='shape'
              />
              <feGaussianBlur
                result='effect1_foregroundBlur_214_29697'
                stdDeviation='100'
              />
            </filter>
          </defs>
        </svg>
      </div>
    </>
  )
}
